//@ts-ignore
import GatewayLogo from '../images/organizations/gateway.jpg';
//@ts-ignore
import CharusatLogo from '../images/organizations/charusat.jpg';
//@ts-ignore
import FreelanceLogo from '../images/organizations/freelance.jpg';
import moment from 'moment';

export const ExperienceData = [
  {
    organizationProfile: {
      title: 'Gateway Group of Companies',
      location: 'Ahmadabad, India',
      imageUrl: GatewayLogo
    },
    relevantBackground: [
      {
        title: 'Sr. Engineer - Software Development',
        location: 'Vadodara, India',
        startingFrom: moment('01/08/2025', 'DD/MM/YYYY').valueOf(),
        endedAt: ''
      },
      {
        title: 'Engineer - Software Development',
        location: 'Vadodara, India',
        startingFrom: moment('01/08/2022', 'DD/MM/YYYY').valueOf(),
        endedAt: moment('31/07/2025', 'DD/MM/YYYY').valueOf()
      },
      {
        title: 'Project Trainee',
        location: 'Ahmadabad, India',
        startingFrom: moment('01/01/2022', 'DD/MM/YYYY').valueOf(),
        endedAt: moment('01/07/2022', 'DD/MM/YYYY').valueOf()
      },
      {
        title: 'Pre-Project Trainee',
        location: 'Ahmadabad, India',
        startingFrom: moment('01/12/2021', 'DD/MM/YYYY').valueOf(),
        endedAt: moment('01/01/2022', 'DD/MM/YYYY').valueOf()
      }
    ]
  },
  {
    organizationProfile: {
      // title: 'Charotar University of Science and Technology',
      title: 'CHARUSAT',
      location: 'Anand, India',
      imageUrl: CharusatLogo
    },
    relevantBackground: [
      {
        title: 'IEC Charusat Web Portal Developer',
        location: 'Anand, India',
        startingFrom: moment('01/04/2021', 'DD/MM/YYYY').valueOf(),
        endedAt: moment('01/10/2021', 'DD/MM/YYYY').valueOf()
      },
      {
        title: 'Charusat Pathology Lab Android App Developer',
        location: 'Anand, India',
        startingFrom: moment('01/08/2021', 'DD/MM/YYYY').valueOf(),
        endedAt: moment('01/09/2021', 'DD/MM/YYYY').valueOf()
      },
      {
        title: "IGNITE'21 Web-App Developer",
        location: 'Anand, India',
        startingFrom: moment('01/01/2021', 'DD/MM/YYYY').valueOf(),
        endedAt: moment('01/03/2021', 'DD/MM/YYYY').valueOf()
      }
    ]
  },
  {
    organizationProfile: {
      title: 'Freelancing',
      location: 'Home, India',
      imageUrl: FreelanceLogo
    },
    relevantBackground: [
      {
        title: 'WooCommerce Developer',
        location: 'Home, India',
        startingFrom: moment('01/05/2020', 'DD/MM/YYYY').valueOf(),
        endedAt: moment('01/08/2020', 'DD/MM/YYYY').valueOf()
      },
      {
        title: 'Wordpress Developer',
        location: 'Home, India',
        startingFrom: moment('01/11/2020', 'DD/MM/YYYY').valueOf(),
        endedAt: moment('01/12/2020', 'DD/MM/YYYY').valueOf()
      }
    ]
  }
];
